const TextFeildType = { text: "text", password: "password", ssn: "ssn" };
export default TextFeildType;
